export class ShowUserNotificationsMessage {}

export class HideUserNotificationsMessage {}